import URL from '../helper';
import axiosCall from './interceptor';

export const uploadDataSet = async (id, payload) => {
  const url = `${URL.BASE_URL}live/uploadDataSet?channel=print`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const uploadDataSetTransaction = async (name, payload,synchronous) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}live/uploadDataSet?batchName=${encodeURIComponent(name)}&channel=print&synchronous=${synchronous}`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const generateBatchFromDraft = async (id, payload, name,synchronous ) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}draftBulkUpload?channel=print&batchName=${encodeURIComponent(name)}&synchronous=${synchronous}`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
}
export const staticDownload = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}downloadZip`;
  const response = await axiosCall('post', url, payload, true, false, true);
  return response;
}